<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <base-material-card
          color="primary"
          icon="mdi-office-building-outline"
          inline
          class="px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              {{labelHeading}}
            </div>
          </template>
          <v-form class="pt-5">
            <v-row align="center" no-gutters class="ml-0">
              <v-text-field
                label="Database"
                outlined
                v-model="database"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

            <v-row align="center" no-gutters class="ml-0">
              <v-text-field
                label="Nome"
                outlined
                v-model="nome"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

            <v-row align="center" no-gutters class="ml-0">
              <v-text-field
                label="Nome Hexa"
                outlined
                v-model="nomeHexa"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

            <v-row align="center" no-gutters class="ml-0">
              <v-text-field
                label="Sigla"
                outlined
                v-model="sigla"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

            <v-row align="center" no-gutters class="ml-0">
              <v-text-field
                label="Url"
                outlined
                v-model="url"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

            <v-row>
              <v-col class="mt-n10 ml-4">
                <v-checkbox
                  prepend-icon=""
                  label="Norven Geo"
                  v-model="hexaMaps"
                />
              </v-col>
            </v-row>

            <v-row align="center" no-gutters class="ml-0" v-if="hexaMaps">
              <v-text-field
                label="ID no Norven Geo"
                outlined
                v-model="hexaMapsEmpresaId"
                class="ml-4"
                prepend-icon=""
              />
            </v-row>

          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6"> </v-col>
      <v-col cols="12" md="6">
        <v-btn
          color="green"
          min-width="100"
          style="float: right"
          class="mt-n5"
          :loading="loading"
          @click="salvarEmpresa"
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Firestore from "@/Firestore.js";

export default {
  name: "EditEmpresa",

  data: () => ({
    database: "",
    hexaMaps: false,
    hexaMapsEmpresaId: "",
    nome: "",
    nomeHexa: "",
    sigla: "",
    url: "",
    loading: false
  }),

  mounted() {
    if (this.$route.params.id) {
      this.getEmpresa();
    }
  },

  methods: {
    getEmpresa() {
      Firestore.collection("empresas")
        .doc(this.$route.params.id)
        .get()
        .then(doc => {
          this.database = doc.data().database || "";
          this.hexaMaps = doc.data().hexa_maps || false;
          this.hexaMapsEmpresaId = doc.data().hexa_maps_empresa_id || "";
          this.nome = doc.data().nome || "";
          this.nomeHexa = doc.data().nome_hexa || "";
          this.sigla = doc.data().sigla || "";
          this.url = doc.data().url || "";
        });
    },

    salvarEmpresa() {
      this.loading = true;

      if (!this.$route.params.id) {
        Firestore.collection("empresas")
          .add({
            database: this.database,
            hexa_maps: this.hexaMaps,
            hexa_maps_empresa_id: this.hexaMapsEmpresaId,
            nome: this.nome,
            nome_hexa: this.nomeHexa,
            sigla: this.sigla,
            url: this.url
          })
          .then(docRef => {
            this.$toast.success("Empresa cadastrada com sucesso.", "", {position: "topRight"});
            console.log("Empresa cadastrada com ID: ", docRef.id);
            this.$router.push("/administracao/empresas");
          })
          .catch(error => {
            this.$toast.error("Erro ao cadastrar empresa.", "", {position: "topRight"});
            console.error("Erro ao cadastrar empresa: ", error);
          })
          .finally(() => this.loading = false);
      } else {
        Firestore.collection("empresas")
          .doc(this.$route.params.id)
          .set({
            database: this.database,
            hexa_maps: this.hexaMaps,
            hexa_maps_empresa_id: this.hexaMapsEmpresaId,
            nome: this.nome,
            nome_hexa: this.nomeHexa,
            sigla: this.sigla,
            url: this.url
          })
          .then(() => {
            this.$toast.success("Empresa atualizada com sucesso.", "", {position: "topRight"});
            this.$router.push("/administracao/empresas");
          })
          .catch(error => {
            this.$toast.error("Erro ao atualizar empresa.", "", {position: "topRight"});
            console.error("Error writing document: ", error);
          })
          .finally(() => this.loading = false);
      }
    }
  },

  computed: {
    labelHeading() {
      return this.$route.name === 'Empresas Adicionar' ? 'Adicionar Nova Empresa' : `Editando Empresa ${this.sigla}`;
    }
  }
};
</script>